import styled from '@emotion/styled';
import { Body } from '@components/templates';

export const StyledTabs = styled.ul<{ tab: 'inbound' | 'outbound' }>`
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
  margin-top: 10px;
  font-size: 18px;

  li {
    width: 136px;
    text-align: center;
    line-height: 38px;
    color: #999999;
    cursor: pointer;

    &.active {
      color: #7fe200;
      font-weight: 600;

      &:before {
        content: '';
        position: absolute;
        width: 136px;
        height: 2px;
        left: ${(props) => (props.tab === 'inbound' ? 0 : 136)}px;
        bottom: 0;
        z-index: 9;
        background-color: #7fe200;
      }
    }
  }

  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 272px;
    height: 2px;
    background-color: #999999;
  }
`;

export const StyledLearnMore = styled.span`
  color: #555555;
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
`;

export const StyledMiddleLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 14px;

  a {
    color: black;
    font-weight: 700;
  }
`;

export const StyledTotal = styled.div`
  span + span {
    margin-left: 4px;
  }
`;

export const PACSLogBody = styled(Body)`
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  & > div:nth-of-type(1) {
    margin-left: 0;
  }
`;
